import { render, staticRenderFns } from "./index-online-learning.vue?vue&type=template&id=7c5a906e&"
import script from "./index-online-learning.vue?vue&type=script&lang=js&"
export * from "./index-online-learning.vue?vue&type=script&lang=js&"
import style0 from "./index-online-learning.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports